angular.module('app.marcacion', [
  'ui.router',
  'toastr',
  'app.marcacionService',
  'app.usuarioService'
])

  .config(
    ['$stateProvider', '$urlRouterProvider',
      function ($stateProvider, $urlRouterProvider) {
        $stateProvider
          .state('index.marcacion', {

            abstract: true,

            url: 'marcacion',

            params: {

            },

            views: {
              '': {
                templateUrl: 'app/marcacion/marcacion.tpl.html',
                resolve:
                  {
                  },
                controller: ['$scope', '$state', 'toastr',
                  function ($scope, $state, toastr) {
                  }]
              }
            }
          })

          .state('index.marcacion.control', {

            url: '/control',

            views: {
              '': {
                templateUrl: 'app/marcacion/marcacion.control.tpl.html',
                resolve: {
                  dataCentros: ['marcacionService',
                    function (marcacionService) {
                    return marcacionService.getCentrosMediacion();
                    }],
                  dataTipoVisualizacion: ['marcacionService',
                    function (marcacionService) {
                    return marcacionService.getTipoVisualizacionMarcacion();
                    }]
                  },
                controller: ['$scope', 'marcacionService', 'toastr', 'ngDialog', 'authService', 'dataCentros', 'dataTipoVisualizacion',
                  function ($scope, marcacionService, toastr, ngDialog, authService, dataCentros, dataTipoVisualizacion) {
                    fechaFormatoYYYYMMDD = function (date)
                      {
                        if (date != undefined)
                        {
                          d = new Date(date);
                          month = '' + (d.getMonth() + 1);
                          day = '' + d.getDate();
                          year = d.getFullYear();
                          if (month.length < 2) month = '0' + month;
                          if (day.length < 2) day = '0' + day;
                          return [year, month, day].join('-');
                        }
                        else
                        return "";
                      }

                    $scope.dataCentros = [];
                    $scope.dataCentros = dataCentros.data;
                    $scope.dataTipoVisualizacion = [];
                    $scope.dataTipoVisualizacion = dataTipoVisualizacion.data;
                    $scope.marcacion = {};
                    $scope.marcacion.ID_DESPACHO = $scope.CONSTANTES.REGISTRO_FALSO;
                    $scope.marcacion.ID_USUARIO = $scope.CONSTANTES.REGISTRO_FALSO;
                    $scope.marcacion.ID_TIPO_VISUALIZACION = $scope.CONSTANTES.REGISTRO_FALSO;
                    $scope.marcacion.FECHA_INICIO = new Date();
                    $scope.marcacion.FECHA_FIN = new Date();

                    $scope.getPersonalCentro = function(despacho)
                    {
                      marcacionService.getPersonalCentro(despacho).then(
                        function ( response ) 
                        {
                          $scope.dataPersonal = [];
                          $scope.dataPersonal = response.data;
                          if ($scope.dataPersonal.length==2)
                          {
                            $scope.marcacion.ID_USUARIO = $scope.dataPersonal[1].ID_USUARIO;
                          }
                          else
                          {
                            $scope.marcacion.ID_USUARIO = $scope.CONSTANTES.REGISTRO_FALSO;
                          }
                          $scope.selectedVisualizacion();
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                    }
                    $scope.getPersonalCentro($scope.CONSTANTES.REGISTRO_FALSO);

                    $scope.selectedCentro = function()
                    {
                      $scope.getPersonalCentro($scope.marcacion.ID_DESPACHO);
                    }

                    $scope.selectedVisualizacion = function()
                    {
                      $scope.marcacion.TIPO_VISUALIZACION = $scope.dataTipoVisualizacion[$scope.marcacion.ID_TIPO_VISUALIZACION].TIPO_VISUALIZACION;
                      $scope.marcacion.TIPO_VISUALIZACION = $scope.marcacion.TIPO_VISUALIZACION.toLowerCase();
                      $scope.marcacion.TIPO_VISUALIZACION = $scope.marcacion.TIPO_VISUALIZACION.charAt(0).toUpperCase() + $scope.marcacion.TIPO_VISUALIZACION.slice(1);
                      if ($scope.marcacion.ID_TIPO_VISUALIZACION == $scope.CONSTANTES.REGISTRO_FALSO)
                      {
                        $scope.getMarcacion($scope.marcacion.ID_DESPACHO,$scope.marcacion.ID_USUARIO,$scope.marcacion.FECHA_INICIO,$scope.marcacion.FECHA_FIN);
                      }
                      if ($scope.marcacion.ID_TIPO_VISUALIZACION == $scope.CONSTANTES.REGISTRO_VERDADERO)
                      {
                        $scope.getDetalleMarcacion($scope.marcacion.ID_DESPACHO,$scope.marcacion.ID_USUARIO,$scope.marcacion.FECHA_INICIO,$scope.marcacion.FECHA_FIN);
                      }
                    }

                    $scope.getDetalleMarcacion = function(despacho,usuario,fecha_inicio,fecha_fin)
                    {
                      marcacionService.getDetalleMarcacion(despacho,usuario,fechaFormatoYYYYMMDD(fecha_inicio),fechaFormatoYYYYMMDD(fecha_fin)).then(
                        function ( response ) 
                        {
                          $scope.marcaciones = [];
                          $scope.marcaciones = response.data;
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                    }

                    $scope.getMarcacion = function(despacho,usuario,fecha_inicio,fecha_fin)
                    {
                      marcacionService.getMarcacion(despacho,usuario,fechaFormatoYYYYMMDD(fecha_inicio),fechaFormatoYYYYMMDD(fecha_fin)).then(
                        function ( response ) 
                        {
                          $scope.marcaciones = [];
                          $scope.marcaciones = response.data;
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                    }
                    $scope.selectedVisualizacion();

                    $scope.editarJustificacion = function(item)
                    {
                      if (item.FIN_SEMANA == $scope.CONSTANTES.REGISTRO_VERDADERO)
                      {
                        //$scope.selectedVisualizacion();
                        item.isSelected=false;
                        toastr.warning("Registro de fin de semana no se puede editar");
                      }
                      else
                      {
                        $scope.marcacionJustificada = {};
                        angular.copy(item,$scope.marcacionJustificada);
                        $scope.marcacionJustificada.ID_TIPO_JUSTIFICACION = "";
                        $scope.marcacionJustificada.ID_MARCACION = "";
                        viewJustificacionMarcacion();
                      }
                    }
                    

                    /*---------------viewJustificacionMarcacion---------------*/
                    viewJustificacionMarcacion = function()
                    {
                      $scope.dialogShowJustificacionMarcacion = ngDialog.open(
                      {
                        template: 'app/marcacion/marcacion.justificacion.view.tpl.html',
                        showClose: true,
                        closeByEscape: true,
                        closeByNavigation: true,
                        preCloseCallback:function()
                        {
                          $scope.selectedVisualizacion();  
                        },
                        className: 'ngdialog-theme-flat-custom custom-width-5',
                        scope:$scope,
                        resolve: {
                          dataTipoJustificacion: ['marcacionService',
                            function (marcacionService) {
                            return marcacionService.getTipoJustificacion();
                            }]
                          },
                        controller: ['$scope', 'dataTipoJustificacion', function($scope,dataTipoJustificacion) 
                        {
                          fechaJustificacionFormatoYYYYMMDD = function (date)
                          {
                            parts =date.split('/');
                            return [parts[2], parts[1], parts[0]].join('-');
                          }
                          
                          
                          
                          $scope.tipoJustificacion = [];
                          $scope.tipoJustificacion = dataTipoJustificacion.data;

                          $scope.JUSTIFICACION_OBLIGATORIA = true;
                          $scope.MOSTRAR_JUSTIFICACION = false;
                          $scope.MOSTRAR_ELIMINACION = false;
                          $scope.tiempo_focus = "500";
                          cargarMarcacionDia = function(ID_USUARIO,FECHA)
                          {
                            marcacionService.getMarcacionDia(ID_USUARIO,fechaJustificacionFormatoYYYYMMDD(FECHA)).then(
                              function ( response ) 
                              {
                                $scope.marcacionDia = [];
                                $scope.marcacionDia = response.data;
                                if ($scope.marcacionDia.length==0)
                                {
                                  $scope.MOSTRAR_JUSTIFICACION = true;
                                }
                              },
                              function ( error ) 
                              {
                                toastr.error( error );
                              });
                          }
                          cargarMarcacionDia($scope.marcacionJustificada.ID_USUARIO,$scope.marcacionJustificada.FECHA);
                          
                          $scope.selectedTipoJustificacion = function(item)
                          {
                            $scope.marcacionJustificada.JUSTIFICACION = "";
                            $scope.JUSTIFICACION_OBLIGATORIA = true;
                            if (item.ID_TIPO_JUSTIFICACION == $scope.CONSTANTES.TIPO_JUSTIFICACION)
                            {
                              $scope.JUSTIFICACION_OBLIGATORIA = false;
                            }
                          }

                          $scope.verificaCaracteres = function(item)
                          {
                            $scope.JUSTIFICACION_OBLIGATORIA = false;
                            if (item.length>=15)
                            {
                              $scope.JUSTIFICACION_OBLIGATORIA = true;
                            }
                          }

                          $scope.seleccionaMarcacion = function(item)
                          {
                            if (item.isSelected)
                            {
                              $scope.marcacionJustificada.ID_MARCACION = item.ID_MARCACION;
                              $scope.marcacionJustificada.ID_TIPO_JUSTIFICACION = item.ID_TIPO_JUSTIFICACION;
                              $scope.marcacionJustificada.JUSTIFICACION = item.JUSTIFICACION;
                              $scope.MOSTRAR_JUSTIFICACION = true;
                              if ($scope.marcacionJustificada.ID_TIPO_JUSTIFICACION != "")
                              {
                                $scope.MOSTRAR_ELIMINACION = true;
                              }
                            }
                            else
                            {
                              $scope.marcacionJustificada.ID_MARCACION = "";
                              $scope.marcacionJustificada.ID_TIPO_JUSTIFICACION = "";
                              $scope.marcacionJustificada.JUSTIFICACION = "";
                              $scope.MOSTRAR_JUSTIFICACION = false;
                              $scope.MOSTRAR_ELIMINACION = false;
                            } 
                          }

                          $scope.guardarJustificacion = function(isValid)
                          {
                            if ((isValid) && ($scope.JUSTIFICACION_OBLIGATORIA) && ($scope.MOSTRAR_JUSTIFICACION))
                              {
                                if ($scope.marcacionJustificada.ID_MARCACION > 0)
                                {
                                  marcacionService.edtMarcacion($scope.marcacionJustificada).then(
                                    function (response)
                                    {
                                      if(response.data.result=='OK')
                                      {
                                        toastr.success(response.data.msj);
                                        cargarMarcacionDia($scope.marcacionJustificada.ID_USUARIO,$scope.marcacionJustificada.FECHA);
                                        $scope.MOSTRAR_JUSTIFICACION = false;
                                        $scope.marcacionJustificada.ID_TIPO_JUSTIFICACION = "";
                                      }
                                      else
                                      {
                                        toastr.error(response.data.msj);
                                      }                      
                                    },
                                    function (error) 
                                    {
                                      toastr.error( error );
                                    }); 
                                }
                                else
                                {
                                  marcacionService.insMarcacion($scope.marcacionJustificada).then(
                                    function (response)
                                    {
                                      if(response.data.result=='OK')
                                      {
                                        toastr.success(response.data.msj);
                                        cargarMarcacionDia($scope.marcacionJustificada.ID_USUARIO,$scope.marcacionJustificada.FECHA);
                                        $scope.MOSTRAR_JUSTIFICACION = false;
                                        $scope.marcacionJustificada.ID_TIPO_JUSTIFICACION = "";
                                      }
                                      else
                                      {
                                        toastr.error(response.data.msj);
                                      }                      
                                    },
                                    function (error) 
                                    {
                                      toastr.error( error );
                                    }); 
                                }
                              }
                              else
                              {
                                toastr.warning("Faltan datos por ingresar");
                              }
                          }

                          $scope.eliminarJustificacion = function()
                          {
                            marcacionService.delMarcacion($scope.marcacionJustificada).then(
                              function (response)
                              {
                                if(response.data.result=='OK')
                                {
                                  toastr.success(response.data.msj);
                                  cargarMarcacionDia($scope.marcacionJustificada.ID_USUARIO,$scope.marcacionJustificada.FECHA);
                                  $scope.MOSTRAR_JUSTIFICACION = false;
                                  $scope.marcacionJustificada.ID_TIPO_JUSTIFICACION = "";
                                }
                                else
                                {
                                  toastr.error(response.data.msj);
                                }                      
                              },
                              function (error) 
                              {
                                toastr.error( error );
                              }); 
                          }

                          /*ID_USUARIO_TEMP = item.ID_USUARIO;
                          cargarCentrosUsuario = function(ID_USUARIO)
                          {
                            authService.getCentrosCargosUsuario(ID_USUARIO).then(
                              function ( response ) 
                                {
                                  $scope.centros = [];
                                  $scope.centros = response.data;
                                },
                              function ( error ) 
                              {
                                toastr.error( error );
                              });
                            }
                          cargarCentrosUsuario(ID_USUARIO_TEMP);
                          $scope.activarCentro = function(item) 
                          {
                            item.ID_ESTADO_MARCACION = $scope.CONSTANTES.ESTADO_ACTIVO;
                            edtAsignacionMarcacionLocal(item);
                          }
                          $scope.desactivarCentro = function(item) 
                          {
                            item.ID_ESTADO_MARCACION = $scope.CONSTANTES.ESTADO_INACTIVO;
                            edtAsignacionMarcacionLocal(item);
                          }

                          edtAsignacionMarcacionLocal = function(item)
                          {
                            marcacionService.edtAsignacionMarcacionLocal(item).then(
                              function (response)
                              {
                                if(response.data.result=='OK')
                                {
                                  toastr.success(response.data.msj);
                                  // getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                                  //$scope.atencion = {};
                                  //ngDialog.closeAll();
                                  cargarCentrosUsuario(ID_USUARIO_TEMP);
                                  $scope.getUsuariosSistema();
                                }
                                else
                                {
                                  toastr.error(response.data.msj);
                                }                      
                              },
                              function (error) 
                              {
                                toastr.error( error );
                              }); 
                          }*/
                          
                          /*$scope.selectCentro = function( item ) 
                          {
                            $scope.loginData.CENTRO = {};
                            $scope.loginData.CENTRO.ID_DESPACHO = item.ID_DESPACHO;
                            $scope.loginData.CENTRO.CODIGO_DESPACHO = item.CODIGO_DESPACHO;
                            if ($scope.loginData.CENTROS[0].ID_CARGO == $scope.CONSTANTES.CARGO_SUPERVISOR)
                            {
                              $scope.loginData.CENTRO.CODIGO_DESPACHO = '**999';
                            }
                            $scope.loginData.CENTRO.DESPACHO = item.DESPACHO;
                            $scope.loginData.CENTRO.CARGO = item.CARGO;
                            $scope.loginData.CENTRO.ID_CARGO = item.ID_CARGO;
                            cerrarViewCentrosCargosUsuario = false;
                            $scope.loginData.CENTRO.CAMBIO=$scope.mostrarCambioCentro;
                            authService.saveLocalData("CENTRO",$scope.loginData.CENTRO);
                            toastr.success('Centro seleccionado exitosamente'); 
                            ngDialog.closeAll();
                            $state.reload();
                          }*/
                        }]
                      });  
                    }
                    /*---------------viewJustificacionMarcacion---------------*/



                  }]
                }
              }
  
            })

          .state('index.marcacion.usuario', {

            url: '/usuarios',

            views: {
              '': {
                templateUrl: 'app/marcacion/marcacion.usuario.tpl.html',
                resolve: {
                  },
                controller: ['$scope', 'marcacionService', 'toastr', 'ngDialog', 'usuarioService',
                  function ($scope, marcacionService, toastr, ngDialog, usuarioService) {
                    $scope.getUsuariosSistema = function()
                    {
                      usuarioService.getUsuariosSistema().then(
                        function ( response ) 
                        {
                          $scope.usuarios = [];
                          $scope.usuarios = response.data;
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                    }
                    $scope.getUsuariosSistema();
                    $scope.editarCentroUsuario = function(item)
                    {
                      viewCentrosUsuario(item);
                    }
                    /*---------------viewCentrosCargosUsuario---------------*/
                    viewCentrosUsuario = function(item)
                    {
                      $scope.dialogShowCentrosUsuario = ngDialog.open(
                      {
                        template: 'app/marcacion/marcacion.centros.view.tpl.html',
                        showClose: true,
                        closeByEscape: true,
                        closeByNavigation: true,
                        preCloseCallback:function()
                        {
                          $scope.getUsuariosSistema();  
                        },
                        className: 'ngdialog-theme-flat-custom custom-width-5',
                        scope:$scope,
                        width:'500px',
                        controller: ['$scope', '$state', 'authService', function($scope,$state,authService) 
                        {
                          ID_USUARIO_TEMP = item.ID_USUARIO;
                          cargarCentrosUsuario = function(ID_USUARIO)
                          {
                            authService.getCentrosCargosUsuario(ID_USUARIO).then(
                              function ( response ) 
                                {
                                  $scope.centros = [];
                                  $scope.centros = response.data;
                                },
                              function ( error ) 
                              {
                                toastr.error( error );
                              });
                            }
                          cargarCentrosUsuario(ID_USUARIO_TEMP);
                          $scope.activarCentro = function(item) 
                          {
                            item.ID_ESTADO_MARCACION = $scope.CONSTANTES.ESTADO_ACTIVO;
                            edtAsignacionMarcacionLocal(item);
                          }
                          $scope.desactivarCentro = function(item) 
                          {
                            item.ID_ESTADO_MARCACION = $scope.CONSTANTES.ESTADO_INACTIVO;
                            edtAsignacionMarcacionLocal(item);
                          }

                          edtAsignacionMarcacionLocal = function(item)
                          {
                            marcacionService.edtAsignacionMarcacionLocal(item).then(
                              function (response)
                              {
                                if(response.data.result=='OK')
                                {
                                  toastr.success(response.data.msj);
                                  // getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                                  //$scope.atencion = {};
                                  //ngDialog.closeAll();
                                  cargarCentrosUsuario(ID_USUARIO_TEMP);
                                  //$scope.getUsuariosSistema();
                                }
                                else
                                {
                                  toastr.error(response.data.msj);
                                }                      
                              },
                              function (error) 
                              {
                                toastr.error( error );
                              }); 
                          }
                          
                          /*$scope.selectCentro = function( item ) 
                          {
                            $scope.loginData.CENTRO = {};
                            $scope.loginData.CENTRO.ID_DESPACHO = item.ID_DESPACHO;
                            $scope.loginData.CENTRO.CODIGO_DESPACHO = item.CODIGO_DESPACHO;
                            if ($scope.loginData.CENTROS[0].ID_CARGO == $scope.CONSTANTES.CARGO_SUPERVISOR)
                            {
                              $scope.loginData.CENTRO.CODIGO_DESPACHO = '**999';
                            }
                            $scope.loginData.CENTRO.DESPACHO = item.DESPACHO;
                            $scope.loginData.CENTRO.CARGO = item.CARGO;
                            $scope.loginData.CENTRO.ID_CARGO = item.ID_CARGO;
                            cerrarViewCentrosCargosUsuario = false;
                            $scope.loginData.CENTRO.CAMBIO=$scope.mostrarCambioCentro;
                            authService.saveLocalData("CENTRO",$scope.loginData.CENTRO);
                            toastr.success('Centro seleccionado exitosamente'); 
                            ngDialog.closeAll();
                            $state.reload();
                          }*/
                        }]
                      });  
                    }
                    /*---------------viewCentrosCargosUsuario---------------*/
                    /*
                    CENTRO = authService.getLocalData('CENTRO');         
                    $scope.deshabilitar_centros = true;
                    $scope.mostrar_centros = false;

                    $scope.deshabilitar_opciones_atencion = false;
                    if ((CENTRO.ID_CARGO != $scope.CONSTANTES.CARGO_ASISTENTE) &&
                        (CENTRO.ID_CARGO != $scope.CONSTANTES.CARGO_MEDIADOR))
                    {
                      $scope.deshabilitar_opciones_atencion = true; 
                      $scope.mostrar_centros = true;
                      $scope.deshabilitar_centros = false;
                    }

                    getAtenciones = function(despacho,anio)
                    {
                      marcacionService.getAtenciones(despacho,anio).then(
                        function ( response ) 
                        {
                          $scope.atenciones = [];
                          $scope.atenciones = response.data;
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                    }

                    //se obtienen los centros de mediacion
                    $scope.centros = [];
                    $scope.centros = dataDespacho.data;

                    //se selecciona el anio de los casos a desplegar en pantalla
                    $scope.selectedAnioCasos = function (item)
                    {
                      $scope.centros.ANIO = item.ANIO;
                      getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                    }
                    //se obtienen los mediadores segun centro
                    getAnioCasos = function(despacho,opcion)
                    {
                      casosService.getAnioCasos(despacho,opcion).then(
                        function ( response ) 
                        {
                          $scope.anioCasos = [];
                          $scope.anioCasos = response.data;
                          if ($scope.anioCasos.length > 0)
                          {
                            $scope.selectedAnioCasos(response.data[0]);
                          }
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        }); 
                    }

                    $scope.selectedCentro = function (item)
                    {
                      $scope.centros.ID_DESPACHO = item.ID_DESPACHO;
                      $scope.centros.ANIO="";
                      $scope.atenciones = [];
                      getAnioCasos($scope.centros.ID_DESPACHO, $scope.CONSTANTES.ANIOS_ATENCION);
                    }
                    if ((CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_ASISTENTE) ||
                        (CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_MEDIADOR))
                    {
                      $scope.selectedCentro({ID_DESPACHO:CENTRO.ID_DESPACHO});
                    }

                    $scope.viewAtencion = function(edicion,item)
                    {
                      $scope.dialogShowAtencion = ngDialog.open(
                      {
                        template: 'app/atencion/atencion.gestionar.tpl.html',
                        resolve: {
                          dataTipoIdentificacion: ['casosService',
                            function (casosService) {
                              return casosService.getTipoIdentificacion($scope.CONSTANTES.TIPO_SUJETO_NATURAL);
                            }],
                          dataGenero: ['casosService',
                            function(casosService)
                            {
                            return casosService.getGenero();
                            }],
                          dataMediador: ['casosService',
                            function(casosService)
                            {
                            return casosService.getMediadoresCentro(CENTRO.ID_DESPACHO, $scope.loginData.ID_USUARIO, $scope.CONSTANTES.CARGO_ASISTENTE);
                            }],
                          dataIdioma: ['casosService',
                            function(casosService)
                            {
                            return casosService.getIdioma(0,0,$scope.CONSTANTES.TIPO_CLS_IDIOMA_SESION);
                            }],
                          dataTiempoAtencion: ['marcacionService',
                            function(marcacionService)
                            {
                            return marcacionService.getTiempoAtencion();
                            }]
                          },
                        showClose: true,
                        closeByEscape: true,
                        closeByNavigation: true,
                        preCloseCallback:function()
                        {
                          if ($scope.centros.ANIO == "")
                          {
                            getAnioCasos($scope.centros.ID_DESPACHO, $scope.CONSTANTES.ANIOS_ATENCION);
                          }
                          if (($scope.atenciones.length > 0) && ($scope.centros.ANIO != ""))
                          {
                            getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                          }
                        },
                        className: 'ngdialog-theme-flat-custom',
                        scope:$scope,
                        controller: ['$scope', 'dataTipoIdentificacion', 'dataGenero', 'dataMediador', 'dataIdioma', 'dataTiempoAtencion', 
                        'casosService', 'marcacionService',
                          function($scope, dataTipoIdentificacion, dataGenero, dataMediador, dataIdioma, dataTiempoAtencion, 
                            casosService, marcacionService) 
                        {
                          //se inicializa el arreglo de los tipos de identificacion
                          $scope.tipoIdentificacion = [];
                          $scope.tipoIdentificacion = dataTipoIdentificacion.data;
                          
                          //se inicializa el arreglo del sexo del sujeto
                          $scope.generos = [];
                          $scope.generos = dataGenero.data;
                          
                          //se inicializa el arreglo de mediadores
                          $scope.mediadoresCentro = [];
                          $scope.mediadoresCentro = dataMediador.data;

                          //se inicializa el arreglo de tiempo de atencion
                          $scope.duracionAtencion = [];
                          $scope.duracionAtencion = dataTiempoAtencion.data;

                          //se inicializa el arreglo de idiomas
                          $scope.idiomasAtencion = [];
                          $scope.idiomasAtencion = dataIdioma.data;

                          $scope.UBICACION_CORRECTA = true;
                          $scope.deshabilitar_datos_atencion = false;
                          $scope.tiempo_focus="500";
                          $scope.atencion = {};
                          
                          $scope.cambiar_focus_identificacion = function()
                          {
                            $scope.focus_identificacion_atencion = false;
                            $scope.UBICACION_CORRECTA = false;
                            if ((($scope.atencion.IDENTIFICACION != undefined) && 
                                  ($scope.atencion.IDENTIFICACION != "")) || 
                                ($scope.atencion.ID_TIPO_IDENTIFICACION != $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)) 
                            {
                              $scope.UBICACION_CORRECTA = true;
                            }
                          }
                          $scope.cambiar_focus_identificacion();

                          getUbicacionNacimiento = function(IDENTIFICACION)
                          {
                            IDENTIFICACION = IDENTIFICACION.replace(/\s/g, "");
                            IDENTIFICACION = IDENTIFICACION.substring(IDENTIFICACION.length-4, IDENTIFICACION.length);                      
                            casosService.getUbicacionNacimiento(IDENTIFICACION).then(
                              function ( response ) 
                              { 
                                if (response.data.id == 0)
                                {
                                  toastr.warning(response.data.msj);
                                  $scope.mensaje_ubicacion_incorrecta = response.data.msj
                                  $scope.UBICACION_CORRECTA = false;
                                }
                                else
                                {
                                  $scope.UBICACION_CORRECTA = true;
                                }
                              },
                              function ( error ) 
                              {
                                toastr.error( error );
                              });  
                          }

                          validaUbicacionNacimiento = function()
                          {
                            if (($scope.atencion.IDENTIFICACION != undefined) && 
                                      ($scope.atencion.IDENTIFICACION != "") &&
                                      ($scope.atencion.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI))
                              {
                                getUbicacionNacimiento($scope.atencion.IDENTIFICACION);
                              }
                          }

                          $scope.valida_identificacion = function(IDENTIFICACION)
                          {
                            if (IDENTIFICACION != undefined)
                            {
                              if (contador_mensajes_invalidos < 100) 
                              {
                                validaUbicacionNacimiento();
                              }
                              contador_mensajes_invalidos++;
                            }
                          }

                          $scope.reinicio_contado_mensajes_invalidos = function()
                          {
                            contador_mensajes_invalidos = 0;
                            // $scope.cambiar_focus_identificacion();
                          }
                          $scope.reinicio_contado_mensajes_invalidos();

                          $scope.valida_enfoque_identificacion = function()
                          {
                            if (($scope.atencion.IDENTIFICACION == undefined) || 
                                  ($scope.atencion.IDENTIFICACION == ""))
                            {
                              $scope.UBICACION_CORRECTA = true;
                            }
                          }

                          $scope.selectedTipoIdentificacion = function (item)
                          {
                            $scope.atencion.ID_TIPO_IDENTIFICACION = item.ID_TIPO_IDENTIFICACION;
                            $scope.atencion.MASCARA_IDENTIFICACION = item.MASCARA;
                            $scope.focus_identificacion_atencion = true;
                          }

                          $scope.verificar_longitud = function(longitud)
                          {  
                            $scope.LONGITUD_DESCRIPCION_ATENCION = false;
                            if (longitud >= $scope.CONSTANTES.LONGITUD_DESCRIPCION_ATENCION)
                            {
                              $scope.LONGITUD_DESCRIPCION_ATENCION = true;
                            }   
                          }

                          //funciones formulario sesion
                          fechaFormatoYYYYMMDD = function (date)
                          {
                            if (date != undefined)
                            {
                              d = new Date(date);
                              month = '' + (d.getMonth() + 1);
                              day = '' + d.getDate();
                              year = d.getFullYear();
                              if (month.length < 2) month = '0' + month;
                              if (day.length < 2) day = '0' + day;
                              return [year, month, day].join('-');
                            }
                            else
                            return "";
                          }

                          buscarMediadorCentro = function(valor, arreglo)
                          {
                            for (var i=0; i < arreglo.length; i++) 
                            {
                              if (arreglo[i].ID_MEDIADOR === valor) 
                              { 
                                return true;
                              }
                            }
                            return false;
                          }

                          $scope.guardarAtencion = function(isValid,genero,longitud_descripcion)
                          {
                            if ((isValid) && (genero != undefined) && (longitud_descripcion))
                            {
                              if (edicion)
                              {
                                marcacionService.edtAtencion($scope.atencion).then(
                                  function (response)
                                  {
                                    if(response.data.result=='OK')
                                    {
                                      toastr.success(response.data.msj);
                                      // getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                                      $scope.atencion = {};
                                      ngDialog.closeAll();
                                    }
                                    else
                                    {
                                      toastr.error(response.data.msj);
                                    }                      
                                  },
                                  function (error) 
                                  {
                                    toastr.error( error );
                                  }); 
                              }
                              else
                              {
                                marcacionService.insAtencion($scope.atencion).then(
                                  function (response)
                                  {
                                    if(response.data.result=='OK')
                                    {
                                      toastr.success(response.data.msj);
                                      // getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                                      $scope.atencion = {};
                                      ngDialog.closeAll();
                                    }
                                    else
                                    {
                                      toastr.error(response.data.msj);
                                    }                      
                                  },
                                  function (error) 
                                  {
                                    toastr.error( error );
                                  }); 
                              }
                            }
                            else
                            {
                              toastr.warning("Faltan datos por ingresar");
                            }
                          }
                    
                          $scope.descripcion_formulario_atencion = "Atención a usuario"

                          if (edicion)
                          {
                            $scope.tooltip_boton_guardar_atencion ="Guardar cambios";
                            $scope.atencion = item;
                            $scope.atencion.FECHA_REGISTRO = fechaFormatoYYYYMMDD($scope.atencion.FECHA_REGISTRO) + ' 00:00:00.0';
                            $scope.LONGITUD_DESCRIPCION_ATENCION = true;
                            if ($scope.atencion.ATENCION_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                            {
                              $scope.deshabilitar_datos_atencion = true;
                            }
                             $scope.mostrar_combo_mediador = buscarMediadorCentro(item.ID_MEDIADOR,$scope.mediadoresCentro);
                             
                            // if ()
                            // {
                            //   $scope.mostrar_combo_mediador = false;
                            // }
                            // console.log('edicion',$scope.mostrar_combo_mediador);
                          }
                          else
                          {
                            $scope.tooltip_boton_guardar_atencion ="Guardar atención";
                            if ($scope.mediadoresCentro.length == 1)
                            {
                              $scope.atencion.ID_MEDIADOR = $scope.mediadoresCentro[0].ID_MEDIADOR;
                            }
                            $scope.atencion.FECHA_REGISTRO = fechaFormatoYYYYMMDD(new Date()) + ' 00:00:00.0';
                            $scope.atencion.ID_DESPACHO = CENTRO.ID_DESPACHO;
                            $scope.mostrar_combo_mediador = true;
                            
                          }

                        }] 
                      });  
                    }
*/

                    // $scope.viewAtencion();
                     
                            
                  }]
              }
            }
          })
      }
    ]
  );